import Vue from "vue";
import axios from "axios";
import qs from "qs";
import { Bus } from "@/Bus";


// === STATE =====================================================================================
const state = {
	token: undefined,
	token_is_valid: false,
	user_details: "",
	user_permissions: [],
	error_message: ""
};


// === GETTERS =====================================================================================
const getters = {
	user: function (state) { return state; },
	user_details: state => { return state.user_details; },
	user_permissions: state => { return state.user_permissions; },
	is_connected: function (state) {
		if (state.token && state.token_is_valid) return true;
		return false;
	}
};


// === ACTIONS =====================================================================================
const actions = {

	async login ({ commit, dispatch }, data) {
		dispatch("set_loading", { loading: true });
		commit("EDIT_USER_STATE", { error_message: "" });

		const values = {};
		if (data.login) values.email = data.login;
		if (data.password) values.password = data.password;
		values.application = "backoffice";
		try {
			let response = false;
			let userGet = null;
			let tokenGet = null;
			let islogged = false;
			
			const payload = data.token ? null : qs.stringify(values); // if there is no token, we call the route with credentials

			if(data.token){
				commit("EDIT_USER_STATE", { token: data.token }); // if there is already a token, we call the route with it
			}
			response = await axios.post(process.env.VUE_APP_API_BASE_URL + "api/login", payload);
			
			if ((response && response.status == 200 && response.data.entity)) {
				userGet = response.data.entity;
				tokenGet = response.data.token;
				islogged = true;
			}
			
			if (islogged) {
				commit("EDIT_USER_STATE", { token: tokenGet.value });
				commit("EDIT_USER_STATE", { token_is_valid: true });
				commit("EDIT_USER_STATE", { user_details: userGet });

				if (data.stay_connected) {
					localStorage.setItem("lli-token", tokenGet.value );
					localStorage.setItem("lli-user", userGet.email);
				}
			
				if (data.callback) data.callback();
				
				Bus.$emit("logged");
			}
			
		} catch (error) {
			// display error message send from login api
			//console.log('error : ',error)
			//const message = error.response.data.message;
			const message = "Votre session a expirée, veuillez vous reconnecter.";//error;
			commit("EDIT_USER_STATE", { error_message: message });
			
			console.error("authentication ERROR : ",error);
			commit("EDIT_USER_STATE", { token: "" });
			localStorage.removeItem("lli-token");
			localStorage.removeItem("lli-user");
			if (data.callback){
				data.callback();
			}
			Bus.$emit("login-error");
			dispatch("set_loading", { loading: false });
			
		}
	},


	logout: async function ({ commit },data) {
		if (state.token != undefined && state.token != "" ){
			// don't call when there is no token to avoid infinite loop because of 401 response
			if(!(data && data.token_expiry)){
				await axios.post(process.env.VUE_APP_API_BASE_URL + "api/logout");
			}
		}
		commit("EDIT_USER_STATE", { token: "",error_message: "Votre session a expirée, veuillez vous reconnecter." });
		localStorage.removeItem("lli-token");
		localStorage.removeItem("lli-user");
	}


};


// === MUTATIONS =====================================================================================
const mutations = {

	EDIT_USER_STATE: function (state, data) {
		for (const i in data) {
			Vue.set(state, i, data[i]);
		}
	},

};

export default { state, getters, actions, mutations };